
  import { Component, Ref, Vue } from 'vue-property-decorator';
  import { Action } from 'vuex-class';

  import Generic from '../../types/app/generic/generic';
  import Endpoint from '../../utils/endpoint';

  @Component({})
  export default class RegulatoryBody extends Vue {
    endpoint = new Endpoint();
    @Action('setSnackbar', { namespace: 'app' }) setSnackbar!: any;

    valid = null;
    saving = false;
    loading = false;
    rules = [
      v => !!v || 'This field is required'
      //v => (v && v.length <= 10) || 'Name must be less than 10 characters'
    ];
    isCreate = true;

    regulatoryBody: Generic = {
      name: '',
      shortName: '',
      active: true
    };

    async created() {
      this.isCreate = !this.$route.params.id;
      if (!this.isCreate) {
        this.loading = true;
        await this.getRegulatoryBodies();
      }
    }

    get title(): string {
      return this.isCreate ? 'Create Regulatory Body' : 'Regulatory Body Detail';
    }

    async getRegulatoryBodies(): Promise<void> {
      this.loading = true;
      const response = await this.$http.get(`${this.endpoint.regulatoryBody.getById}/${this.$route.params.id}`);

      if (response.status == 200) {
        this.regulatoryBody = response.data.data;
        this.loading = false;
      }
    }

    async save(): Promise<void> {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        if (this.isCreate) {
          await this.create();
        } else {
          await this.update();
        }
      }
    }

    async update(): Promise<void> {
      this.saving = true;

      const response = await this.$http.put(
        `${this.endpoint.regulatoryBody.update}/${this.$route.params.id}`,
        this.regulatoryBody
      );

      if (response.status == 200) {
        this.saving = false;

        this.setSnackbar({
          show: true,
          message: 'Regulatory body update',
          color: 'success'
        });

        this.$router.push({ name: 'IndexRegulatoryBody' });
      } else {
        this.saving = false;
        console.log('erro...', response);
      }
    }

    async create(): Promise<void> {
      this.saving = true;

      const response = await this.$http.post(this.endpoint.regulatoryBody.create, this.regulatoryBody);

      if (response.status == 200) {
        this.saving = false;

        this.setSnackbar({
          show: true,
          message: 'Regulatory body saved',
          color: 'success'
        });

        this.$router.push({ name: 'IndexRegulatoryBody' });
      }

      if (response.status != 200) {
        this.saving = false;
      }
    }
  }
